import { useComponentOrder } from './useComponentOrder';

const goalsWithComponentName: Map<string, string> = new Map<string, string>([
  ['I_WANT_RETIREMENT', 'RETIREMENT'],
  ['I_WANT_DREAM', 'DREAM'],
  ['I_WANT_LEGACY', 'LEGACY'],
  ['I_WANT_SECURE_FAMILY', 'SECURE_FAMILY'],
  ['I_WANT_PRESERVE_CAPITAL', 'PRESERVE_CAPITAL'],
]);

const defaultGoalsOrder: string[] = ['RETIREMENT', 'LEGACY', 'DREAM', 'PRESERVE_CAPITAL', 'SECURE_FAMILY'];

export const useLayoutGoalsOrder = () => {
  const goals: Map<number, string> = new Map<number, string>([]);

  goalsWithComponentName.forEach((value, key) => {
    const index = useComponentOrder(key);
    if (index !== undefined) {
      goals.set(index, value);
    }
  });
  const goalsOrder = new Map([...goals.entries()].sort());

  return goalsOrder.size > 0 ? Array.from(goalsOrder.values()) : defaultGoalsOrder;
};
